/**
 * Shared Tailwind utility classes for rendering GitHub-style markdown alert
 * blocks (`> [!WARNING]`, `> [!CAUTION]`) inside `MarkdownContent`. Hides the
 * alert-title paragraph and recolors the left border per alert type.
 *
 * Used by both AuditSummary and EventProcessedEvent so their alert rendering
 * can never silently drift out of visual sync.
 */
export const MARKDOWN_ALERT_CLASSNAME =
  '[&_.markdown-alert>p:first-child]:hidden [&_.markdown-alert>p:nth-child(2)>br:first-child]:hidden [&_.markdown-alert-warning]:!border-l-[var(--color-fg-warning-primary)] [&_.markdown-alert-caution]:!border-l-[var(--color-text-error-primary)]';
